
import React, { useState } from 'react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ProductMediaProps {
  images: string[];
  productName: string;
}

const ProductMedia = ({ images, productName }: ProductMediaProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Use a placeholder image if no images are provided
  const imageList = images.length > 0 ? images : ['/placeholder.svg'];
  
  console.log("ProductMedia rendering with images:", imageList);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? imageList.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === imageList.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="relative">
      <AspectRatio ratio={1 / 1} className="bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden">
        <img
          src={imageList[currentIndex]}
          alt={`${productName} - Image ${currentIndex + 1}`}
          className="w-full h-full object-cover"
          onError={(e) => {
            // If image fails to load, attempt to log the error and use placeholder
            console.error(`Error loading image: ${imageList[currentIndex]}`);
            e.currentTarget.src = '/placeholder.svg';
          }}
        />
      </AspectRatio>

      {imageList.length > 1 && (
        <div className="absolute inset-x-0 bottom-0 flex justify-between p-2">
          <Button
            variant="secondary"
            size="icon"
            className="rounded-full bg-white/80 dark:bg-gray-900/80"
            onClick={handlePrev}
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="sr-only">Previous image</span>
          </Button>
          <Button
            variant="secondary"
            size="icon"
            className="rounded-full bg-white/80 dark:bg-gray-900/80"
            onClick={handleNext}
          >
            <ArrowRight className="h-4 w-4" />
            <span className="sr-only">Next image</span>
          </Button>
        </div>
      )}

      {imageList.length > 1 && (
        <div className="flex justify-center mt-2 gap-2">
          {imageList.map((_, i) => (
            <button
              key={i}
              className={`w-2 h-2 rounded-full ${
                i === currentIndex ? 'bg-primary' : 'bg-gray-300 dark:bg-gray-600'
              }`}
              onClick={() => setCurrentIndex(i)}
              aria-label={`Go to image ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductMedia;
